import React from 'react';
import ChangeRoom from './ChangeRoom';
import Back from './Back';
import Hand from './Hand';
import { connect } from 'react-redux';
import _ from 'lodash';
import { hideHand } from '../../../actions';
import RoomEditor from './RoomEditor'

const AppartmentView = ({ dispatch, appartments, match, scrollWebsite }) => appartments.length ? (
    <div className="App360">
        <div style={{ height: "100%" }}>
            <iframe src={ _.find(_.find(appartments, { Id: match.params.appartmentId }).Rooms, { Id: match.params.roomId }).IframeUrl } onMouseUp={e => dispatch(hideHand())} width="100%" title="view" />
            <div className="flecheappart">
                <img src="kozySlider/images/fleche-bottom.png" alt="arrow down" className="arrowDown" onClick={scrollWebsite} />
                <img src="kozySlider/images/fleche-bottom-mobile.png" alt="arrow down" className="arrowDownMobile" onClick={scrollWebsite} />
            </div>
            <ChangeRoom match={match} />
            <Back />
            <Hand />
            <RoomEditor appartmentId={ match.params.appartmentId } roomId={ match.params.roomId } />
        </div>
    </div>
) : null

export { AppartmentView };

export default connect(
    (state) => state.app
)(AppartmentView);



// WEBPACK FOOTER //
// ./src/components/360Mode/AppartmentView/AppartmentView.js